export default __webpack_public_path__ + "static/media/char.1372ac4d.png";